import React from "react";
import { Outlet } from "react-router-dom";

const Settings=()=>{
    return(
        <div className="dashRightView home_section">
            {/* <div className="container-fluid"> */}
            <Outlet />
          {/* </div> */}
        </div>

    );
}

export default Settings;